/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 旗舰店pc端导航栏管理列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  type: "PC_SHOP" | "APP_SHOP",

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.NavigationPCDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/shops/navigation/${type}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
